import React, { useEffect, useState } from "react";
import { getTrades } from "../services/api.js";

export default function TradeHistory(){
  const [rows, setRows] = useState([]);
  const [error, setError] = useState("");

  useEffect(()=>{
    (async()=>{
      try{ setRows(await getTrades()); }
      catch(e){ setError(e.message||"Fehler"); }
    })();
  },[]);

  if (error) return <div className="card">Trade-Historie: <span className="text-red-600">{error}</span></div>;

  if (!rows || !rows.length){
    return (
      <div className="card">
        <div className="font-semibold mb-2">Trade-Historie</div>
        <div className="text-sm opacity-70">
          Kein Endpoint <code>/trades</code> gefunden oder keine Daten vorhanden.
          Nutze alternativ das Export-Panel, um Trades als CSV zu laden.
        </div>
      </div>
    );
  }

  return (
    <div className="card overflow-x-auto">
      <div className="font-semibold mb-2">Trade-Historie</div>
      <table className="w-full text-sm border-collapse">
        <thead><tr className="bg-gray-100">
          <th className="border px-2 py-1">Datum</th>
          <th className="border px-2 py-1">Symbol</th>
          <th className="border px-2 py-1">Side</th>
          <th className="border px-2 py-1">Qty</th>
          <th className="border px-2 py-1">Entry</th>
          <th className="border px-2 py-1">Exit</th>
          <th className="border px-2 py-1">P&L</th>
        </tr></thead>
        <tbody>
          {rows.map((r,i)=>(
            <tr key={i}>
              <td className="border px-2 py-1">{r.date || r.ts_close || r.ts_open || ""}</td>
              <td className="border px-2 py-1">{r.symbol}</td>
              <td className="border px-2 py-1">{r.side}</td>
              <td className="border px-2 py-1">{r.qty}</td>
              <td className="border px-2 py-1">{r.price || r.entry}</td>
              <td className="border px-2 py-1">{r.exit_price || ""}</td>
              <td className="border px-2 py-1">{r.pnl_abs ?? r.pnl ?? 0}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}